module.exports = __webpack_public_path__ + "static/social-interactions-1-ab4c8ea812173eed56a5f72dbd784025.jpg";